import * as _ from 'lodash';

export const isRowEmpty = (row) => {
    if (!row) return true;
    if (isCellEmpty(row.input) && isCellEmpty(row.query) && isCellEmpty(row.prompt) && isCellEmpty(row.result)) {
        return true;
    }
    return false;
};

function isCellEmpty(cell) {
    return _.isEmpty(cell) || (_.isString(cell) && cell.trim() === '');
}